import { ConfirmOTPDto } from '../../../dto/otp/confirmotp/confirmotpdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface ConfirmOTPRequest extends APIRequest
{
    getConfirmOTPRequest(): ConfirmOTPDto;
}

export class ConfirmOTPRequestImpl extends APIRequestDtoImpl implements ConfirmOTPRequest
{
    constructor(private ConfirmOTPData: ConfirmOTPDto)
    {
        super();
    }

    getConfirmOTPRequest(): ConfirmOTPDto
    {
        return this.ConfirmOTPData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotprequest.tsx